import { ComponentProps } from "react";

interface DocumentsEmptyProps extends ComponentProps<"svg"> {
  circleColor?: string;
  primaryColor?: string;
  secondaryColor?: string;
  tertiaryColor?: string;
}

const DocumentsEmpty = ({
  circleColor = "#CCE4E6",
  primaryColor = "#4C9FA6",
  secondaryColor = "#005661",
  tertiaryColor = "#E5F1F2",
  className,
  ...props
}: DocumentsEmptyProps) => {
  return (
    <svg
      width="161"
      height="161"
      viewBox="0 0 161 161"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Background circle */}
      <circle cx="80.5" cy="80.5" r="80.5" fill={circleColor} />

      <g opacity="0.7">
        <path
          d="M40.4175 24.457H111.698C115.275 24.457 118.178 27.2899 118.178 30.7803V119.812C118.178 123.303 115.275 126.136 111.698 126.136H40.4175C36.8406 126.136 33.9375 123.303 33.9375 119.812V30.7803C33.9375 27.2899 36.8406 24.457 40.4175 24.457Z"
          fill={primaryColor}
        />

        <path
          d="M50.1136 42.2627H72.4049C74.1934 42.2627 75.6449 43.6791 75.6449 45.4243V64.6472C75.6449 66.3924 74.1934 67.8089 72.4049 67.8089H50.1136C48.3251 67.8089 46.8735 66.3924 46.8735 64.6472V45.4243C46.8735 43.6791 48.3251 42.2627 50.1136 42.2627Z"
          fill={secondaryColor}
        />

        {/* These all use tertiary color */}
        <path
          d="M46.8447 79.1543C46.8447 80.4063 47.8945 81.4307 49.1775 81.4307H102.832C104.115 81.4307 105.165 80.4063 105.165 79.1543C105.165 77.9023 104.115 76.8779 102.832 76.8779H49.1775C47.8945 76.8779 46.8447 77.9023 46.8447 79.1543Z"
          fill={tertiaryColor}
        />
        <path
          d="M83.7847 65.4961C83.7847 66.7481 84.8344 67.7725 86.1175 67.7725H102.836C104.119 67.7725 105.169 66.7481 105.169 65.4961C105.169 64.2441 104.119 63.2197 102.836 63.2197H86.1175C84.8344 63.2197 83.7847 64.2441 83.7847 65.4961Z"
          fill={tertiaryColor}
        />
        <path
          d="M83.7847 51.8379C83.7847 53.0899 84.8344 54.1143 86.1175 54.1143H102.836C104.119 54.1143 105.169 53.0899 105.169 51.8379C105.169 50.5859 104.119 49.5615 102.836 49.5615H86.1175C84.8344 49.5615 83.7847 50.5859 83.7847 51.8379Z"
          fill={tertiaryColor}
        />
        <path
          d="M46.8447 92.8125C46.8447 94.0645 47.8945 95.0889 49.1775 95.0889H102.832C104.115 95.0889 105.165 94.0645 105.165 92.8125C105.165 91.5605 104.115 90.5361 102.832 90.5361H49.1775C47.8945 90.5361 46.8447 91.5605 46.8447 92.8125Z"
          fill={tertiaryColor}
        />
        <path
          d="M46.8447 106.47C46.8447 107.722 47.8945 108.746 49.1775 108.746H102.832C104.115 108.746 105.165 107.722 105.165 106.47C105.165 105.218 104.115 104.193 102.832 104.193H49.1775C47.8945 104.193 46.8447 105.218 46.8447 106.47Z"
          fill={tertiaryColor}
        />
      </g>

      <path
        d="M64.7021 29.4272L133.554 47.8759C137.009 48.8017 139.08 52.2894 138.176 55.6609L115.133 141.659C114.23 145.031 110.692 147.016 107.237 146.09L38.3857 127.641C34.9306 126.716 32.8597 123.228 33.7631 119.856L56.8063 33.8578C57.7097 30.4863 61.247 28.5014 64.7021 29.4272Z"
        fill={primaryColor}
      />

      <path
        d="M69.4592 49.1355L90.991 54.9049C92.7185 55.3678 93.754 57.1116 93.3023 58.7974L88.3271 77.3652C87.8754 79.051 86.1067 80.0435 84.3791 79.5806L62.8474 73.8111C61.1198 73.3483 60.0844 71.6044 60.5361 69.9186L65.5113 51.3508C65.963 49.665 67.7317 48.6726 69.4592 49.1355Z"
        fill={secondaryColor}
      />

      {/* Bottom tertiary paths */}
      <path
        d="M56.7536 83.9244C56.4296 85.1338 57.1784 86.3949 58.4178 86.727L110.244 100.614C111.484 100.946 112.763 100.228 113.087 99.0188C113.411 97.8095 112.662 96.5483 111.423 96.2162L59.5961 82.3294C58.3568 81.9973 57.0776 82.7151 56.7536 83.9244Z"
        fill={tertiaryColor}
      />
      <path
        d="M95.9699 80.2916C95.6459 81.501 96.3947 82.7621 97.6341 83.0942L113.783 87.4213C115.022 87.7533 116.301 87.0356 116.625 85.8262C116.949 84.6169 116.201 83.3557 114.961 83.0236L98.8124 78.6965C97.5731 78.3645 96.294 79.0822 95.9699 80.2916Z"
        fill={tertiaryColor}
      />
      <path
        d="M99.5051 67.0992C99.181 68.3086 99.9299 69.5697 101.169 69.9018L117.318 74.2289C118.557 74.561 119.836 73.8432 120.161 72.6338C120.485 71.4245 119.736 70.1633 118.496 69.8312L102.348 65.5042C101.108 65.1721 99.8291 65.8899 99.5051 67.0992Z"
        fill={tertiaryColor}
      />
      <path
        d="M53.2184 97.1158C52.8944 98.3252 53.6433 99.5863 54.8826 99.9184L106.709 113.805C107.948 114.137 109.228 113.42 109.552 112.21C109.876 111.001 109.127 109.74 107.887 109.408L56.0609 95.5208C54.8216 95.1887 53.5425 95.9065 53.2184 97.1158Z"
        fill={tertiaryColor}
      />
      <path
        d="M49.6833 110.309C49.3592 111.519 50.1081 112.78 51.3474 113.112L103.174 126.999C104.413 127.331 105.692 126.613 106.016 125.404C106.34 124.194 105.592 122.933 104.352 122.601L52.5258 108.714C51.2865 108.382 50.0073 109.1 49.6833 110.309Z"
        fill={tertiaryColor}
      />
    </svg>
  );
};

export default DocumentsEmpty;
